import React from "react";

export const Background = ({ intense = false }) => {
    const opacity = intense ? 0.12 : 0.06;
    return (
        <div className="fixed inset-0 pointer-events-none z-0" aria-hidden>
            <div className="absolute inset-0 bg-grid" style={{ opacity: 0.03 }} />
            <div
                className="orb orb-primary orb-drift-1"
                style={{ width: 620, height: 620, top: -180, left: -120, opacity }}
            />
            <div
                className="orb orb-success orb-drift-2"
                style={{ width: 640, height: 640, bottom: -200, right: -160, opacity }}
            />
        </div>
    );
};

export default Background;
